import {createEffect} from "effector";
import {api} from "../../api/axiosInstance.js";

export const getOrganizationFx = createEffect()
	.use(async (id) => {
		return (await api().get(`/organization/${id}`)).data
	})
